import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { IdpContractPeriod } from '../../models/idpContracts';
import { TenantService } from '../tenant-id/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class IdpContractsApiService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private tenantService = inject(TenantService);

  private baseUrl = environment.urls.autoclassifierApi;

  /**
   *
   */
  getContracts(): Observable<IdpContractPeriod[]> {
    const authToken = this.authService.getAuthToken();
    const tenantId = this.tenantService.getTenantId();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${authToken}`,
      tenantId: tenantId
    });

    const url = `${this.baseUrl}/idpcontracts`;

    return this.http.get<IdpContractPeriod[]>(url, { headers }).pipe(
      catchError(error => {
        console.error('Error fetching IDP contracts:', error);
        return throwError(() => error);
      })
    );
  }
}
